<lib-page-layout>
  <lib-title-navbar
    pageHeader
    extended
    [title]="navbarTitle()"
    [showDots]="canShowOptions()"
    (onDotsClicked)="onDotsClicked()"></lib-title-navbar>

  <div pageHeader class="or-d-flex or-justify-content-center z-index-999 negative-top-margin-35-px">
    @if (userDetails(); as details) {
      <div class="or-position-relative">
        <lib-or-avatar
          [avatarUrl]="details.thumbnail"
          [avatarSize]="'lg'"
          [initials]="details.displayName"
          [rightMargin]="false"
          [priority]="true"></lib-or-avatar>
        @if (details.isHighlighted) {
          <div #highlightedBadge>
            <or-icon
              (click)="toggleHighlightedTooltip()"
              name="highlighted"
              size="xs"
              circle
              class="avatar-highlighted-icon or-cursor-pointer or-color-primary" />
            @if (showHighlightedTooltip()) {
              <div class="highlighted-tooltip or-text-sm or-color-main-1">
                Wyróżnienie za wspieranie rozwoju Orlikfy
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div pageHeader class="or-d-flex or-flex-col or-align-items-center or-mt-12-px or-mb-4-px">
    @if (userDetails(); as details) {
      <div class="or-d-flex or-align-items-center">
        <div class="or-head-lg">{{ details.displayName }}</div>
        @if (details.rating?.hostRating) {
          <or-icon name="star" size="xs" class="or-mx-8-px or-mb-2-px or-color-yellow" />
          <div class="or-head-xs">{{ details.rating.hostRating }}</div>
        }
      </div>
      @if (!details.isMyProfile) {
        <div class="or-text-sm or-color-secondary-2">Aktywny {{ calculatelastActive(details.lastActive) }}</div>
      } @else {
        <div class="or-text-sm or-color-secondary-2">{{ details.email }}</div>
      }
    }
  </div>

  @if (userDetails(); as details) {
    @if (!details.isMyProfile) {
      <div class="or-px-20-px or-mt-16-px">
        <button
          (click)="onMessageClicked()"
          class="button-primary-style or-w-100-pc or-d-flex or-align-items-center or-justify-content-center or-py-12-px border-radius-8">
          <or-icon name="contact" size="m" class="or-color-white or-mr-8-px" />
          <span class="or-text-md or-color-white">Wyślij wiadomość</span>
        </button>
      </div>
    }

    <div class="or-px-20-px or-mt-20-px">
      <div class="or-d-flex or-justify-content-between or-mb-12-px preferences-tiles">
        <lib-info-tile
          class="or-w-50-pc or-mr-12-px"
          label="Preferowana pozycja"
          [value]="preferredPosition()"></lib-info-tile>
        <lib-info-tile class="or-w-50-pc" label="Poziom umiejętności" [value]="preferredLevel()"></lib-info-tile>
      </div>
      <div class="or-d-flex or-justify-content-between preferences-tiles">
        <lib-info-tile
          class="or-w-50-pc or-mr-12-px"
          label="Rozegranych gierek"
          [value]="details.userStats.playedGames"></lib-info-tile>
        <lib-info-tile
          class="or-w-50-pc"
          label="Zorganizowanych gierek"
          [value]="details.userStats.hostedGames"></lib-info-tile>
      </div>
    </div>

    @if (details.isMyProfile) {
      <div class="or-px-20-px or-mt-12-px">
        <lib-player-rank></lib-player-rank>
      </div>
    }

    <div class="or-px-20-px or-mt-12-px">
      <lib-card-history></lib-card-history>
    </div>

    <div class="or-px-20-px or-mt-12-px">
      <lib-user-comments></lib-user-comments>
    </div>

    @if (!details.isMyProfile) {
      <div class="or-mt-20-px or-mb-16-px">
        <lib-last-games-carousel [games]="lastFiveGames()"></lib-last-games-carousel>
      </div>
    }

    @if (details.isMyProfile) {
      <div class="or-px-20-px or-mt-12-px or-mb-16-px">
        <div class="or-head-md or-mb-8-px">Ustawienia</div>
        <lib-profile-settings></lib-profile-settings>
      </div>
    }
  }

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
